import React, { useCallback, useId } from 'react';
import { Input, useToast } from 'randmarcomps';
import { usePostV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeImageMutation } from 'randmar-api-client';
import { useManufacturer } from '../../contexts/WithManufacturer';

interface IProps {
  categoryCode?: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const EditCategoryImageWrapper: React.FC<IProps> = ({ categoryCode, children, disabled }) => {
  const { applicationId } = useManufacturer();
  const fileInputId = useId();
  const { toast } = useToast();
  const [uploadImage, { isLoading }] = usePostV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeImageMutation();

  const handleFileChange = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) {
      toast({ variant: "destructive", title: "Error", description: "No file selected." });
      return;
    }

    if (categoryCode) {
      try {
        await uploadImage({
          routeManufacturerId: applicationId,
          categoryCode: categoryCode,
          body: { file: selectedFile },
        }).unwrap();
        toast({ variant: "success", title: "Success", description: "Image uploaded successfully." });
      } catch {
        toast({ variant: "destructive", title: "Error", description: "Failed to upload image." });
      }
    }
  }, [applicationId, categoryCode, toast, uploadImage]);


  if (disabled) return <>{children}</>;

  return (
    <>
      <Input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden"
        id={fileInputId}
        disabled={isLoading}
      />
      <label htmlFor={fileInputId}>
        {children}
      </label>
    </>
  );
};

export default EditCategoryImageWrapper;
